import { render, staticRenderFns } from "./PosesDialog.vue?vue&type=template&id=abd1997e&scoped=true"
import script from "./PosesDialog.vue?vue&type=script&lang=js"
export * from "./PosesDialog.vue?vue&type=script&lang=js"
import style0 from "./PosesDialog.vue?vue&type=style&index=0&id=abd1997e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd1997e",
  null
  
)

export default component.exports